import { render, staticRenderFns } from "./ShopProductList.vue?vue&type=template&id=2f38e9a5&scoped=true&"
import script from "./ShopProductList.vue?vue&type=script&lang=js&"
export * from "./ShopProductList.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductList.vue?vue&type=style&index=0&id=2f38e9a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38e9a5",
  null
  
)

export default component.exports